import React from "react";
import { array } from "prop-types";

import LeftImageRightNews from "../../../../molecules/LeftImageRightNews";

import "./organism2.m.css";

const Organism2 = ({ stories }) =>
  stories.length > 0 && (
    <div styleName="base">
      {stories.map(({ story }, index) => (
        <LeftImageRightNews key={index} story={story} />
      ))}
    </div>
  );

Organism2.propTypes = {
  stories: array.isRequired,
};

export default Organism2;
